export const talkbotEndpoint = 'talkbot';
